<script>
	import * as d3 from "d3"

	export let key = ''
	export let options = []
	export let selected = []
	export let total = 10
	export let title = ''

	let search = '';
	let show = false;
	let select_all = true;

	function toggleOptions() {
		var dropdown = d3.select(`.${key}`)
		dropdown.classed("show-dropdown-content", !dropdown.classed("show-dropdown-content"))
		dropdown.classed("hide-dropdown-content", !dropdown.classed("hide-dropdown-content"))
	}

	function toggleAll() {
		if (!select_all) {
			selected = [...options]
			select_all = true
		} else {
			selected = []
			select_all = false
		}
	}

	$: {if (selected.length === total) {
			select_all = true
		} else {
			select_all = false
		}
	}

	// $:console.log(options[0])

</script>

<style>
	#searchbox {
		background-image: url('https://cdn2.iconfinder.com/data/icons/font-awesome/1792/search-512.png');
		background-position: 10px 12px;
		background-repeat: no-repeat;
		background-size: 15px 15px;
		width: 100%;
		font-size: 12px;
		padding: 12px 20px 12px 40px;
		border: 1px solid #ddd;
		margin-bottom: 12px;
	}

	.dropdown {
		float: left;
		overflow: hidden;
	}

	.dropdown .dropbtn {
		font-size: 12px;  
		border: 1px solid #ddd;
		outline: none;
		color: black;
		padding: 8px 10px;
		background-color: inherit;
		font-family: inherit;
		margin: 0;
		width: 25vw;
		text-align: left;
		display: flex;
    	justify-content: space-between;
    	cursor: pointer;
	}


	.dropdown-content {
		position: absolute;
		background-color: #f9f9f9;
		font-size: 12px;
		min-width: 160px;
		box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
		z-index: 1;
		width: 25vw;
		height: 50vh;
		overflow: scroll;
	}

	.dropdown-content label {
		float: none;
		color: black;
		padding: 0px 0px 5px 10px;
		text-decoration: none;
		text-align: left;
		display: flex;
   		align-content: center;
	}

	.dropdown-content input {
		margin-right: 5px;
		cursor: pointer;
	}

	.hide-dropdown-content {
		display: none;
	}

	.show-dropdown-content {
		display: block;
	}
</style>

<div class="multiselect">
	<h3>{title}</h3>

	<div class="dropdown">
		<button class="dropbtn" on:click|stopPropagation={toggleOptions}>
			{#if selected.length === total}
				(All)
			{:else if selected.length === 1}
				{selected[0]}
			{:else if selected.length === 0}
				(None)
			{:else}
				(Multiple Values)
			{/if}
			<i class="fa fa-caret-down"></i>
		</button>
		<div class={`${key} dropdown-content hide-dropdown-content`}>
			<input id="searchbox" bind:value={search} placeholder="Search for state or zip code">
			<label><input type="checkbox" value={"all"} checked={select_all} on:click={toggleAll}>(All)</label>
			{#each options as value}
				<label style={`display:${value.toString().includes(search) ? 'block':'none'}`}><input type="checkbox" {value} bind:group={selected}>{value}</label>
			{/each}
		</div>
	</div> 
</div>